import produce from 'immer';
import SecureLS from 'secure-ls';
import { Convert, Session } from '../../../interfaces';
import { GET_SESSION } from '../../actions/AccountAction';
import { ApplicationAction } from '../../types';
import {
    AccountState,
    GET_USER_POPROFILE,
    LOGIN_FAILURE,
    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    ProfilState,
    UserState,
    USER_FAILURE,
    USER_REQUEST,
    USER_SUCCESS,
    GET_USER_ROLES, RoleState
} from '../../types/AccountTypes'


const ls = new SecureLS({ encodingType: 'aes' });

let session  = ls.get('session') 

if (session !==undefined  && session !=='')
  session = Convert.toSession(session);
  
else
  session = {
    id:0,
    username: '',
    email:    '',
    profil: undefined,
    type:'',
    token:'',
    expireIn: undefined
  }

const initialState: ProfilState = {
    profile: undefined
}

const initialRoleState: RoleState = {
    roles: undefined
}

const reducer = (state = initialState, action: ApplicationAction) => {
    switch (action.type) {
      case GET_USER_POPROFILE: {
        return produce(state, (draft) => {
            const { profile } = action;
          // Ensure we clear current session

          draft.profile = profile;
        });
      }
    
      default:
          return state
    }
}  

export default reducer